"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _checkbox = require("baseui/checkbox");

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _checkboxStyle = require("./checkboxStyle");

var _toggleStyle = require("./toggleStyle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * This is a basic checkbox form element. It's a thin wrapper around the
 * [baseui checkbox](https://baseweb.design/components/checkbox/), so it supports
 * many of the same props.
 */
const Checkbox = props => {
  const {
    checked,
    children,
    className,
    errored,
    overrides,
    size = 'standard',
    type = 'checkbox',
    onChange,
    ...buiProps
  } = props;
  const CheckboxComponent = (0, _isUndefined.default)(checked) ? _checkbox.StatefulCheckbox : _checkbox.Checkbox;

  function checkboxOnChange(event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
  }

  const hasLabel = children !== null;
  const baseOverrides = type === 'checkbox' ? (0, _checkboxStyle.getOverrides)({
    hasLabel,
    size
  }) : (0, _toggleStyle.getOverrides)({
    hasLabel,
    size
  });
  const checkmarkStyle = {
    checkbox: _checkbox.STYLE_TYPE.default,
    toggle: _checkbox.STYLE_TYPE.toggle_round
  }[type];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(CheckboxComponent, _extends({
    labelPlacement: "right"
  }, buiProps, {
    checkmarkType: checkmarkStyle,
    checked: checked,
    isError: errored,
    onChange: checkboxOnChange,
    overrides: { ...baseOverrides,
      ...(overrides || {})
    }
  }), children));
};

var _default = Checkbox;
exports.default = _default;